(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["About-Us-Description"] && !Shopify.designMode) return;
  try {
    

   // Function to update the sticky heading
function updateStickyHeading() {
  // Check if the device is a desktop (viewport width greater than 768px)
  if (window.innerWidth > 768) {
    var sections = document.querySelectorAll('.article-section');

    // Loop through each section and determine if its description is in view
    sections.forEach(function(section, index) {
      var rect = section.getBoundingClientRect();
      var heading = section.querySelector('.heading');

      // If the description is in view, make the heading sticky
      if (rect.top <= 0) {
        heading.classList.add('sticky');
      } else {
        heading.classList.remove('sticky');
      }
    });
  }
}

// Event listener for scroll event
window.addEventListener('scroll', function() {
  updateStickyHeading();
});

// Event listener for window resize
window.addEventListener('resize', function() {
  updateStickyHeading();
});

// Initial update of sticky heading
updateStickyHeading();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us"] && !Shopify.designMode) return;
  try {
    



function handleFormSubmission(formId, url) {
  var form = document.getElementById(formId);
  if (!form) {
    console.error(`Form with ID '${formId}' not found`);
    return;
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent default form submission
    console.log(`Form '${formId}' submission prevented`);

    var formData = new FormData(this); // Get form data
    console.log(`FormData collected for '${formId}'`);

    fetch(url, {
      method: 'POST',
      body: formData,
    })
    .then(response => {
      console.log(`Response status for '${formId}':`, response.status);
      if (!response.ok) {
        throw new Error(`Network response was not ok for '${formId}'`);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return response.json();
      } else {
        return response.text(); // Handle text response
      }
    })
    .then(data => {
      console.log(`Data received for '${formId}':`, data);
      alert('Message sent successfully!');
    })
    .catch(error => {
      console.error(`There was a problem with the fetch operation for '${formId}':`, error.message);
      console.error(error); // Log full error object for details
      alert('Message failed to send. Please try again later.');
    });
  });
}

// Adjust the URL as needed for each form
handleFormSubmission('contactForm', '/contact');
handleFormSubmission('shareyoureperiencesform', '/contact');

 


document.addEventListener('DOMContentLoaded', function() {
  // Get all links inside .contact-us-tab
  var links = document.querySelectorAll('.contact-us-tab p');
  console.log(links);

  // Attach click event listeners to each link
  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default link behavior

      // Get the target section ID from the target attribute
      var targetId = this.getAttribute('target');

      // Find the target section element by its ID
      var targetSection = document.getElementById(targetId);

      // Calculate the scroll offset (adjust as needed)
      var offset = 100; 

      // Scroll smoothly to the target section with offset
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start', // Scroll to the top of the target section
        inline: 'start', // Scroll to the left of the target section
        offsetTop: offset // Apply the offset
      });

      // Remove the 'active' class from all links
      links.forEach(function(link) {
        link.classList.remove('active');
        
      });

      // Add the 'active' class to the clicked link
      this.classList.add('active');
    });
  });
});


   function openTab(tabName) {
        var i, tabcontent;

        tabcontent = document.getElementsByClassName("content");
        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
          tabcontent[i].classList.remove("active");
        }

        document.getElementById(tabName).style.display = "block";
        document.querySelector(`#${tabName}.content`).classList.add("active");

        // Scroll to the selected tab on mobile devices
        if (window.innerWidth <= 768) {
          var tabElement = document.getElementById(tabName);
          tabElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      document.addEventListener("DOMContentLoaded", function () {
        openTab("content1");

        // Add event listener to select element
        document.getElementById("tabDropdown").addEventListener("change", function() {
          openTab(this.value);
        });
      });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
     var selectElements = document.querySelectorAll("variant-selects .product-form__input select");


    var customSection = document.getElementById("customSection");


    function extractAndDisplayData() {

      customSection.innerHTML = "";


      selectElements.forEach(function(selectElement) {


        var nameParagraph = document.createElement("p");

        var selectName = selectElement.getAttribute("name");
        nameParagraph.textContent = selectName.replace("options[", "").replace("]", "") ;

        customSection.appendChild(nameParagraph);


        var ulElement = document.createElement("ul");


        for (var i = 0; i < selectElement.options.length; i++) {


       var option = selectElement.options[i];
          var optionData = option.value;

          var liElement = document.createElement("li");

          liElement.textContent = optionData;

          ulElement.appendChild(liElement);
        }


        customSection.appendChild(ulElement);
      });
    }


     extractAndDisplayData();




    //   document.addEventListener("DOMContentLoaded", function() {
    //     var content = document.getElementById("product-detail");
    //     var readMoreBtn = document.getElementById("read-more-btn");

    //     if (content.scrollHeight > 300) {
    //         readMoreBtn.style.display = "block";
    //     }

    //     readMoreBtn.addEventListener("click", function() {
    //         content.style.maxHeight = content.style.maxHeight ? null : "100%";

    //         readMoreBtn.innerText = content.style.maxHeight ? "Read Less" : "Read More";

    //     });
    // });


    document.addEventListener("DOMContentLoaded", function() {
      var content1 = document.getElementById("product-details");
      var readMoreBtn1 = document.getElementById("read-more-btns");

      var fullText1 = content1.innerHTML.trim(); // Use innerHTML to keep HTML tags
      var truncatedText1= fullText1.slice(0, 300) + (fullText1.length > 300 ? "..." : "");

      // Show only the first 100 characters initially (with HTML intact)
      content1.innerHTML = truncatedText1;

      if (fullText1.length > 300) {
          readMoreBtn1.style.display = "inline";
      }

      let isExpanded1 = false;

      readMoreBtn1.addEventListener("click", function() {
          isExpanded1 = !isExpanded1;

          // Toggle between full and truncated HTML content
          content1.innerHTML = isExpanded1 ? fullText1 : truncatedText1;
          readMoreBtn1.innerText = isExpanded1 ? "Read Less" : "Read More";
      });
  });




      document.addEventListener("DOMContentLoaded", function() {
            const rows = document.querySelectorAll(".product-charles table tbody tr");
            const toggleButton = document.getElementById("toggle-button");

            // Initially show the first 6 rows
            for (let i = 0; i < 6; i++) {
              if (rows[i]) {
                rows[i].classList.add("visible");
              }
            }


            window.toggleRows = function() {
              const visibleRows = document.querySelectorAll(".product-charles table tbody tr.visible");

              if (visibleRows.length > 6) {
                // If more than 6 rows are visible, hide the extra ones
                for (let i = 6; i < rows.length; i++) {
                  rows[i].classList.remove("visible");
                }
                toggleButton.textContent = "Read More";
              } else {
                // If only 6 rows are visible, show all rows
                for (let i = 6; i < rows.length; i++) {
                  rows[i].classList.add("visible");
                }
                toggleButton.textContent = "Read Less";
              }
            };
          });

  } catch(e) { console.error(e); }
})();
})();
